import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScanPage from "../pages/ScanPage";
// import CaptchaPage from "../pages/CaptchaPage";
import ResultPage from "../pages/ResultPage";
// import ReportsPage from "../pages/ReportsPage";
import ReportAuth from "../components/ReportAuth";
// import StartPage from "../pages/StartPage";

export default function AppRoutes(){
    return (
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          {/* <Route path="/" element={<CaptchaPage />} /> */}
          <Route path="/" element={<ScanPage/>}></Route>
          {/* <Route path="/home" element={<StartPage/>}></Route> */}
          <Route path="/scanner" element={<ScanPage/>}></Route>
          <Route path="/result" element={<ResultPage/>}></Route>
          <Route path="/analytics" element={<ReportAuth />}></Route>
          {/* <Route path="/auth" element={<ReportAuth />}></Route> */}
        </Routes>
      </Router>
    );
}